import React from "react";

interface PercentageLoaderProps {
  progress: number;
  size?: number;
  backgroundStrokeWidth?: number;
  progressStrokeWidth?: number;
  style?: any;
}

const PercentageLoader: React.FC<PercentageLoaderProps> = ({
  progress,
  size = 45,
  backgroundStrokeWidth = 6,
  progressStrokeWidth = 3.5,
  style = {},
}) => {
  const radius =
    size / 2 - Math.max(backgroundStrokeWidth, progressStrokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <div
      style={{
        position: "relative",
        width: `${size}px`,
        height: `${size}px`,
      }}
    >
      <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
        <circle
          stroke="#eee"
          fill="transparent"
          strokeWidth={backgroundStrokeWidth}
          r={radius}
          cx={size / 2}
          cy={size / 2}
        />
        <circle
          stroke="#4caf50"
          fill="transparent"
          strokeWidth={progressStrokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          r={radius}
          cx={size / 2}
          cy={size / 2}
        />
      </svg>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: `${size * 0.3}px`,
          fontWeight: "bold",
        }}
      >
        {Math.min(progress, 100)}%
      </div>
    </div>
  );
};

export default PercentageLoader;
